import MaintainCarrier from './MaintainCarrier.vue';

export default MaintainCarrier;


// WEBPACK FOOTER //
// ./src/components/MaintainCarrier/index.js